/* Cart drawer: fold the long sections away. HEllO EDC, 21 Oct 2026.

   With something in the cart, two blocks sat between the items and the
   checkout button, each one more thing to read past:

     - "Savings to claim at checkout" (HEllO points, FIRSTHELLO, prepaid 2%)
     - "Complete your setup" (spare buckles, straps, WatchLife gear)

   Each now collapses behind one line, and opens on a tap:

     Savings to claim at checkout   HEllO points · FIRSTHELLO · Prepaid 2%   (+)
     Want to add more?  Spare buckles, another strap or WatchLife gear      (+)

   The suggestions still load in the background (assets/hello-cart.js), so
   opening is instant. An empty cart is left alone: there the suggestions are
   the whole point.

   Works on the rendered drawer rather than its Liquid. The drawer is
   re-rendered after every change; a MutationObserver re-folds it before the
   browser paints, and each fold remembers whether it was open for as long
   as the page is open. If this file fails, the cart shows both blocks open,
   exactly as before. */

(function () {
  'use strict';

  if (window.__hcFold) return;
  window.__hcFold = true;

  var ICON = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
    '<path d="M6 1.5v9M1.5 6h9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function perkSummary(wrap) {
    var bits = [];
    wrap.querySelectorAll('.hc-perk').forEach(function (p) {
      var code = p.querySelector('[data-hc-copy]');
      var txt = (p.textContent || '').toLowerCase();
      if (code) bits.push(code.textContent.trim());
      else if (txt.indexOf('point') > -1) bits.push('HEllO points');
      else if (txt.indexOf('prepaid') > -1 || txt.indexOf('online') > -1) bits.push('Prepaid 2%');
    });
    return bits.join(' · ') || 'Offers applied at checkout';
  }

  var FOLDS = [
    {
      id: 'perks',
      wrap: '#CartDrawer section[aria-labelledby="hc-h-perks"]',
      move: ['.hc-perks', '.hc-fine'],
      title: function () { return 'Savings to claim at checkout'; },
      sub: perkSummary,
      open: false
    },
    {
      id: 'ups',
      wrap: '#CartDrawer .hc-ups-wrap',
      move: ['[data-hc-upsells]'],
      title: function () { return 'Want to add more?'; },
      sub: function () { return 'Spare buckles, another strap or WatchLife gear'; },
      open: false
    }
  ];

  function apply(f, wrap) {
    var btn = wrap.querySelector('[data-hc-fold-toggle]');
    var panel = wrap.querySelector('.hc-fold-panel');
    if (wrap.classList.contains('is-open') !== f.open) wrap.classList.toggle('is-open', f.open);
    if (btn && btn.getAttribute('aria-expanded') !== String(f.open)) btn.setAttribute('aria-expanded', String(f.open));
    if (panel && panel.hidden !== !f.open) panel.hidden = !f.open;
  }

  function foldOne(f) {
    var wrap = document.querySelector(f.wrap);
    if (!wrap) return;

    if (!wrap.classList.contains('hc-fold')) {
      var parts = [];
      f.move.forEach(function (sel) { var el = wrap.querySelector(sel); if (el) parts.push(el); });
      if (!parts.length) return;

      wrap.classList.add('hc-fold', 'hc-fold--' + f.id);
      var title = wrap.querySelector('.hc-sec__title');
      if (title) title.classList.add('visually-hidden');

      var pid = 'hc-fold-' + f.id;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hc-fold-toggle';
      btn.setAttribute('data-hc-fold-toggle', f.id);
      btn.setAttribute('aria-controls', pid);
      btn.innerHTML =
        '<span class="hc-fold-toggle__txt"><b></b><span></span></span>' +
        '<span class="hc-fold-toggle__ico">' + ICON + '</span>';
      btn.querySelector('b').textContent = f.title(wrap);
      btn.querySelector('.hc-fold-toggle__txt > span').textContent = f.sub(wrap);

      var panel = document.createElement('div');
      panel.className = 'hc-fold-panel';
      panel.id = pid;
      parts[0].parentNode.insertBefore(panel, parts[0]);
      parts.forEach(function (el) { panel.appendChild(el); });
      wrap.insertBefore(btn, wrap.firstChild);
    }
    apply(f, wrap);
  }

  function fold() {
    if (!document.querySelector('#CartDrawer [data-hc-line]')) return;   /* empty cart: leave open */
    FOLDS.forEach(foldOne);
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-hc-fold-toggle]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-hc-fold-toggle');
    FOLDS.forEach(function (f) {
      if (f.id !== id) return;
      f.open = !f.open;
      var wrap = b.closest('.hc-fold');
      if (wrap) apply(f, wrap);
    });
  });

  function start() {
    fold();
    var root = document.querySelector('cart-drawer') || document.body;
    if (window.MutationObserver && root) {
      new MutationObserver(fold).observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
